import commonNetwork from "../api/commonNetwork" 

export async function controlPaymentLinkPackages(smsCount, emailCount, whatsappCount) {
 
    const params = {
        smsSendCount: smsCount,
        emailSendCount: emailCount,
        whatsappCount : whatsappCount, 
    }
    const result = await commonNetwork.post("/package/paymentLinkPackageControl", params);

    if (result.isSuccess) {

        const { isMailOverflow, mailOverflowCount, isSmsOverflow, smsOverflowCount, isWhatsappOverflow, whatsappOverflowCount } = result.data;
        return {
            isMailOverflow, mailOverflowCount, isSmsOverflow, smsOverflowCount, isWhatsappOverflow, whatsappOverflowCount,
            serviceError: false,
        }

    } else {
        return {
            serviceError: true,
            errorMessage: result.errorMessage.toString()
        }
    }

}